import { render } from "./InputText.vue?vue&type=template&id=713803e6"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"
script.render = render

export default script